import { createAction, handleActions } from 'redux-actions'

/***
 * Common Actions
 *
 * The following actions are globally recognized by one or more subreducers.
 */
export const RESET_GAME = 'BPF_4075/RESET_GAME'
export const resetGame = createAction(RESET_GAME)

export const SET_ROOMS_CLEARED = 'BPF_4075/gameProgress/SET_ROOMS_CLEARED'
export const SET_MODAL_STATUS = 'BPF_4075/gameProgress/SET_MODAL_STATUS'
export const SET_SELECTED_ROOM = 'BPF_4075/gameProgress/SET_SELECTED_ROOM'
export const SET_GAME_FINISHED = 'BPF_4075/gameProgress/SET_GAME_FINISHED'
export const SET_START_BUTTON_URL = 'BPF_4075/gameProgress/SET_START_BUTTON_URL'

const initialState = {
  roomsCleared: [],
  modalIsActive: false,
  selectedRoom: 'living-room',
  gameFinished: false,
  startButtonUrl: '/living-room',
}

export default handleActions(
  {
    // Reset all game state.
    [RESET_GAME]: () => ({ ...initialState }),

    [SET_ROOMS_CLEARED]: (state, { payload }) => ({
      ...state,
      roomsCleared: payload,
    }),
    [SET_MODAL_STATUS]: (state, { payload }) => ({
      ...state,
      modalIsActive: Boolean(payload),
    }),
    [SET_SELECTED_ROOM]: (state, { payload }) => ({
      ...state,
      selectedRoom: payload,
    }),
    [SET_START_BUTTON_URL]: (state, { payload }) => ({
      ...state,
      startButtonUrl: payload,
    }),
    [SET_GAME_FINISHED]: (state, { payload }) => ({
      ...state,
      gameFinished: Boolean(payload),
    }),
  },
  initialState,
)

export const setRoomsCleared = createAction(SET_ROOMS_CLEARED)
export const setModalStatus = createAction(SET_MODAL_STATUS)
export const setSelectedRoom = createAction(SET_SELECTED_ROOM)
export const setGameFinished = createAction(SET_GAME_FINISHED)
export const setStartButtonUrl = createAction(SET_START_BUTTON_URL)



// WEBPACK FOOTER //
// ./src/modules/gameProgress.js